import {Switch} from 'react-router-dom';

import {CustomerExplorePage} from '../../ui/trial-onboarding/explore-page/customer-explore-page';
import {TrialExplorePage} from '../../ui/trial-onboarding/explore-page/trial-explore-page';

import {RestrictedRoute} from '../shared/restricted-route';

export function ExploreRoot() {
    const showCustomerExplorePage =
        NutClientConfig.hasCustomerExplorePageFF && !NutClientConfig.isTrial;

    return (
        <Switch>
            <RestrictedRoute
                path='/explore'
                hasAccess={NutClientConfig.hasTrialOnboarding}
                redirectPath='/sales/dashboard'
                render={() =>
                    showCustomerExplorePage ? <CustomerExplorePage /> : <TrialExplorePage />
                }
            />
        </Switch>
    );
}
